import styled from 'styled-components';

export const FormModalContainer = styled.div`
    width: 569px;
    padding: 20px;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 350px;

    display: flex;
    flex-direction: column;
    align-items: center;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddWorkoutPlanModal/style.js